import {
  GATELOYALTYPOINTOPERATIONSLIST_SUCCESS,
  GATELOYALTYPOINTOPERATIONSLIST_FAILED,
  RESET_GATELOYALTYPOINTOPERATIONSLIST,
  LOADING_GATELOYALTYPOINTOPERATIONSLIST,
  NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GATELOYALTYPOINTOPERATIONSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GATELOYALTYPOINTOPERATIONSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GATELOYALTYPOINTOPERATIONSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GATELOYALTYPOINTOPERATIONSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
